import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PublicationsPage = lazy(() => import('../pages/publications/page'));
const WhitepaperPage = lazy(() => import('../pages/whitepaper/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ConstitutionalAIPage = lazy(() => import('../pages/constitutional-ai/page'));
const AILiabilityPage = lazy(() => import('../pages/ai-liability/page'));
const AISafetyBridgePage = lazy(() => import('../pages/ai-safety-bridge/page'));
const EngineeringTrustPage = lazy(() => import('../pages/engineering-trust/page'));
const StateOfAIPage = lazy(() => import('../pages/state-of-ai/page'));
const StateOfAI2025Page = lazy(() => import('../pages/state-of-ai-2025/page'));
const SurvivalImperativePage = lazy(() => import('../pages/survival-imperative/page'));
const OpenLetterPage = lazy(() => import('../pages/open-letter/page'));
const BookProposalPage = lazy(() => import('../pages/book-proposal/page'));
const PlaybookExecutiveSummaryPage = lazy(() => import('../pages/playbook-executive-summary/page'));
const CAIEngineeringStandardPage = lazy(() => import('../pages/cai-engineering-standard/page'));
const InfographicsPage = lazy(() => import('../pages/infographics/page'));
const NewsroomPage = lazy(() => import('../pages/newsroom/page'));
const TranscriptsPage = lazy(() => import('../pages/transcripts/page'));
const TranscriptAudio1Page = lazy(() => import('../pages/transcript-audio-1/page'));
const TranscriptAudio10Page = lazy(() => import('../pages/transcript-audio-10/page'));
const DesignDefectConstitutionalDesign = lazy(() => import('../pages/design-defect-constitutional-design/page'));
const MediaKitPage = lazy(() => import('../pages/media-kit/page'));
const AnalyticsDashboardPage = lazy(() => import('../pages/analytics-dashboard/page'));
const PressReleaseLaunch = lazy(() => import('../pages/press-release-launch/page'));
const LuevanoStandardPage = lazy(() => import('../pages/luevano-standard/page'));
const GetBookPage = lazy(() => import('../pages/get-book/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/publications',
    element: <PublicationsPage />,
  },
  {
    path: '/whitepaper',
    element: <WhitepaperPage />,
  },
  {
    path: '/state-of-ai',
    element: <StateOfAIPage />,
  },
  {
    path: '/state-of-ai-2025',
    element: <StateOfAI2025Page />,
  },
  {
    path: '/ai-liability',
    element: <AILiabilityPage />,
  },
  {
    path: '/constitutional-ai',
    element: <ConstitutionalAIPage />,
  },
  {
    path: '/cai-engineering-standard',
    element: <CAIEngineeringStandardPage />,
  },
  {
    path: '/infographics',
    element: <InfographicsPage />,
  },
  {
    path: '/analytics',
    element: <AnalyticsDashboardPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/book-proposal',
    element: <BookProposalPage />,
  },
  {
    path: '/engineering-trust',
    element: <EngineeringTrustPage />,
  },
  {
    path: '/survival-imperative',
    element: <SurvivalImperativePage />,
  },
  {
    path: '/ai-safety-bridge',
    element: <AISafetyBridgePage />,
  },
  {
    path: '/open-letter',
    element: <OpenLetterPage />,
  },
  {
    path: '/open-letter-governor-newsom',
    element: <OpenLetterPage />,
  },
  {
    path: '/playbook-executive-summary',
    element: <PlaybookExecutiveSummaryPage />,
  },
  {
    path: '/newsroom',
    element: <NewsroomPage />,
  },
  {
    path: '/transcripts',
    element: <TranscriptsPage />,
  },
  {
    path: '/transcript-audio-1',
    element: <TranscriptAudio1Page />,
  },
  {
    path: '/transcript-audio-10',
    element: <TranscriptAudio10Page />,
  },
  {
    path: '/design-defect-constitutional-design',
    element: <DesignDefectConstitutionalDesign />,
  },
  {
    path: '/media-kit',
    element: <MediaKitPage />,
  },
  {
    path: '/press-release-launch',
    element: <PressReleaseLaunch />,
  },
  {
    path: '/luevano-standard',
    element: <LuevanoStandardPage />,
  },
  {
    path: '/get-book',
    element: <GetBookPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
